import {Workspace} from "../API";
import {WorkspaceModelType} from "../stores/WorkspaceStore";
import intl from "react-intl-universal";

export const workspaceName = (workspace: Workspace | WorkspaceModelType) => {
    return workspace.name ? workspace.name : (
        intl.get('workspace.no-name').d('New Workspace')
    )
}
